import Spinner, { SpinnerProps } from './Spinner';

type CenteredSpinnerProps = SpinnerProps;

const CenteredSpinner = (props: CenteredSpinnerProps) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 9999,
      }}
    >
      <Spinner {...props} />
    </div>
  );
};

export default CenteredSpinner;
